import { render, staticRenderFns } from "./ChatClient.vue?vue&type=template&id=586a5ecc&scoped=true"
import script from "./ChatClient.vue?vue&type=script&lang=js"
export * from "./ChatClient.vue?vue&type=script&lang=js"
import style0 from "./ChatClient.vue?vue&type=style&index=0&id=586a5ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a5ecc",
  null
  
)

export default component.exports